import { useTranslation } from 'react-i18next';
import loadingIcon from '../assets/icons/loading.svg';

const Loading = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center items-center text-center gap-2 w-full">
      <img className="animate-spin" alt="" src={loadingIcon} />
      <div className="font-medium text-lg">{t('general.loading')}</div>
      <div className="text-xs text-gray-500 whitespace-pre-line">
        {t('general.loadingHint')}
      </div>
    </div>
  );
};

export default Loading;
